var render = function render(){var _vm=this,_c=_vm._self._c;return _c('va-page-not-found',{staticClass:"va-page-not-found-simple"},[_c('img',{staticClass:"logo-image",attrs:{"slot":"image","src":require("@/assets/images/logo.svg"),"alt":"Florida"},slot:"image"})])
}
var staticRenderFns = []

export { render, staticRenderFns }